import { render, staticRenderFns } from "./ListCamion.vue?vue&type=template&id=a22da634&scoped=true&"
import script from "./ListCamion.vue?vue&type=script&lang=js&"
export * from "./ListCamion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22da634",
  null
  
)

export default component.exports